import React from "react";
import styled from "styled-components";
import { auth, provider } from "../firebase";

function Login(props) {
  const signIn = () => {
    auth.signInWithPopup(provider).then((result) => {
        const newUser = {
            name: result.user.displayName,
            photo: result.user.photoURL,
        }
        localStorage.setItem('user', JSON.stringify(newUser))
        props.setUser(newUser);
        
      })
      .catch((error) => {
        alert(error.message);
      });
  };

  return (
    <Container>
      <Content>
        <SlackImg src="http://assets.stickpng.com/images/5cb480cd5f1b6d3fbadece79.png" />
        <h1>Slack</h1>
        <SignInButton onClick={() => signIn()}>
          Sign in with Google
        </SignInButton>
      </Content>
      <Footer>
        © 2021 Maria Torres. All Rights Reserved.
      </Footer>
    </Container>
  );
}

export default Login;

const Container = styled.div`
  width: 100%;
  height: 100vh;
  background-color: #3f0e40;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
const Content = styled.div`
  background: white;
  padding: 100px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgb(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const SlackImg = styled.img`
  height: 100px;
`;

const SignInButton = styled.button`
  margin-top: 50px;
  background-color: #0a8d48;
  color: white;
  border: none;
  height: 40px;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 15px;
`;

const Footer = styled.footer`
display: flex;
margin-top: 50px;

color: white;

`
